/** Entries for the project settings search box. */
export const tracksSettingsIndex = [
  {
    label: "Tracks (a language each, with its own people)",
    tab: "Tracks",
    path: "/tracks",
    keywords:
      "tracks languages split parts per language team members assign who works on which language multilingual translate every language",
  },
  {
    label: "A track's own labeling setup",
    tab: "Tracks",
    path: "/tracks",
    keywords:
      "track setup labeling interface per track own questions different setup language specific config answer differently",
  },
  {
    label: "Target, pay and limit per track",
    tab: "Tracks",
    path: "/tracks",
    keywords: "target goal tasks pays rate per answer limit per person cap how many one person may answer track",
  },
  {
    label: "Progress per track",
    tab: "Tracks",
    path: "/tracks",
    keywords: "progress per language track done left answers people numbers download csv",
  },
];
